<template>
  <el-container class="wrapper">
    <layoutHeader></layoutHeader>

    <div @click="toTop" class="to-top"></div>
    <el-main>
      <Breadcrumb
        :afterItem="breadcrumbList"
        :beforeItem="{ name: $t('breadcrumbBefore[0]'), to: '/' }"
        v-if="breadcrumb"
      />

      <slot></slot>
    </el-main>
  </el-container>
</template>
<script>
import layoutAsideAd from '@/components/layout/loyout-aside-ad'
import layoutHeader from '@/components/layout/layout-header'
import Breadcrumb from '@/components/layout/Breadcrumb'
import layoutFooter from '@/components/layout/layout-footer'

export default {
  methods: {
    toTop() {
      document.documentElement.scrollTop = 0
    },
  },
  props: {
    breadcrumb: {
      type: Boolean,
      default: true,
    },
    breadcrumbList: {
      type: [Array, String],
      default: '首页',
    },
  },
  components: {
    layoutAsideAd,
    layoutHeader,
    Breadcrumb,
    layoutFooter,
  },
}
</script>
<style lang="stylus" scoped>
.wrapper {
  min-height: 100vh;
  $toTopSide = 70px;

  .to-top {
    right: 0;
    bottom: 0;
    width: $toTopSide;
    height: $toTopSide;
    position: absolute;
    background-image: url('../../../assets/img/2top.png');
    background-size: $toTopSide $toTopSide;
    cursor: pointer;
  }

  $toTopSide;
  position: relative;
  width: 100%;
  display: flex;
  padding-bottom: $toTopSide;
  flex-direction: column;
}
</style>